import { Pressable } from '@react-aria/interactions'
import Styles from './BasicsCard.module.scss'
import { ReactComponent } from 'react-hotkeys'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  onPress: () => void
  icons: ReactComponent[]
  label: string
}

export const BasicsCard = ({ onPress, icons, label }: Props) => {
  return (
    <Pressable onPress={onPress}>
      <div className={Styles.card}>
        <div className={Styles.icons}>
          {icons.map((Icon, i) => (
            <div className={Styles.iconContainer} key={i}>
              <Icon size={32} />
            </div>
          ))}
        </div>
        <div className={Styles.label}>
          <Text variant="label" color="var(--dark-80)">
            {label}
          </Text>
        </div>
      </div>
    </Pressable>
  )
}
